<modal-header-container [vs]="vs">
  <leplace-toolbar [noBackButton]="true" [rightButton]="rightBtnIcon" [rightIcon]="true" [title]="title"
    (rightClick)="dismiss(null)" [rounded]="vs.fullScreen">
  </leplace-toolbar>
</modal-header-container>

<modal-container [vs]="vs"
  [ngClass]="!vs.fullScreen ? (!vs.large?'modal-small-height':'modal-large-height'):vs.webIOS ? 'full-height-web-ios' : 'full-height'">

  <ion-list class="list-md-noborder" *ngIf="loaded">

    <ion-item class="list-item transparent-bg" *ngFor="let sel of selectors" button detail (click)="openDatetime(sel)">
      <ion-label>{{ sel.heading }}</ion-label>

      <ion-text slot="end">
        {{ sel.value ? (sel.value | date:'dd-MMM-yyyy HH:mm') : 'Select' }}
      </ion-text>
    </ion-item>

  </ion-list>

  <div fxFlex>
  </div>

  <div class="stick-bottom theme-border-top">
    <ion-grid class="full-w">
      <ion-row *ngIf="!withClear">
        <ion-col size="12">
          <ion-button class="action-button-fill button-color-primary" (click)="ok()">
            <span class="button-font-size-m">
              Apply
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="withClear">
        <ion-col size="6">
          <ion-button class="action-button-fill button-color-primary" (click)="clear()">
            <span class="button-font-size-m">
              Clear
            </span>
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button class="action-button-fill button-color-primary" (click)="ok()">
            <span class="button-font-size-m">
              Apply
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</modal-container>

<ion-modal [isOpen]="datetimeOpen" cssClass="datetime-modal" (didDismiss)="datetimeOpen=false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ activeSel?.heading }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="datetimeOpen=false">Done</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="datetime-content">
      <div class="datetime-wrap">
        <ion-datetime presentation="date-time" [min]="activeSel?.minValue" [max]="activeSel?.maxValue"
          [(ngModel)]="activeSel.value" (ionChange)="onChange(activeSel)"></ion-datetime>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>